export enum DriverSocketMsgType {
  MTSelectDevice = 0x02, // 切换选中键盘
  MTSetLed = 0x03, // 设置灯光
  MTSetKey = 0x05, // 设置按键
  MTCurrentDevices = 0x06, // 查看当前连接设备
  MTDeviceVersion = 0x07, // 查看当前设备版本号
  MTSetMacro = 0x08, // 设置宏
  MTSaveSettings = 0x09, // 保存配置
  MTReadSettings = 0x0a, // 读取配置
  MTWatchKey = 0x0b, // 录制宏 开始/结束
  MTSetKeysColor = 0x0c, // 自定义灯光颜色
  MTMouseSet = 0x0d, // 基础设置 （废弃）
  MTSetReset = 0x0e, // 重置
  MTMusicalRhythm = 0x0f, // 音乐律动

  MTUsingDevice = 0x10, // 获取初始化的设备
  MTGetDefineKeys = 0x11, // 获取键盘的kk
  MTPollingRate = 0x12, // 回报率  （只限制exe磁轴使用）
  MTMusicalRhythmEnable = 0x13, // 开启音乐律动状态

  // 配置文件
  MTCfgList = 0x14,
  MTCfgChange = 0x15, // 配置文件发生变化
  MTCfgCreate = 0x16,
  MTCfgDelete = 0x17,
  MTCfgRename = 0x18,
  MTCfgImport = 0x19,
  MTCfgExport = 0x1a,
  MTCfgImportReplace = 0x1b,

  MTCfgBindShortcut = 0x20,
  MTOnboardCfgList = 0x21,
  MTOnboardCfgSync = 0x22,
  MTOnboardCfgRename = 0x23,
  MTOnboardCfgMigrationCheck = 0x25,
  MTOnboardCfgMigrationExecute = 0x26,
  MTOnboardCfgReplaceSlot = 0x27,
  MTReplicateSwitchKeys = 0x28,

  MTMagnetSetKeyInfo = 0x30, //设置按键rt
  MTMagnetGetKeyInfo = 0x31, //获取按键rt
  MTMagnetSetWatch = 0x32, //行程监控
  MTMagnetCalibratin = 0x33, //全部按键校准
  MTMagnetSeniorKey = 0x34,
  MTMagnetSingleCalibratin = 0x35, // 单按键校准
  MTMagnetSetKeyDeadZone = 0x36, //设置按键死区
  MTMagnetGetKeyDeadZone = 0x37, //获取按键死区

  MTSetDPIData = 0x40,
  MTSwitchDPI = 0x41,

  MTVersionSVC = 0x50, // 获取driver.service 的版本号
  MTKillService = 0x51,

  MTSetKeysGroup = 0x60, // 获取按键组
  MTGetKeysGroup = 0x61, // 设置按键组

  MTMusicData = 0x70, // 订阅\取消订阅音乐数据
  MSSendMusicData = 0x71, // 发送音乐数据
  MSMusicSocketClose = 0x72, // 音乐数据连接关闭

  MTPair24G = 0x80,

  MTSetLightDecoration = 0x90, // 设置装饰灯光

  MSMagnetFluxKey = 0xdf, // 按键磁通量
  MSMagnetDynamicKey = 0xe0, // 按键行程值
  MSMagnetWatchCalibratin = 0xe1, // 校准

  MSWatchKey = 0xf0, // 监听按键
  MSWatchDevice = 0xf1, // 监听设备插拔变化
  MSDeviceChange = 0xf2,
  MSMagnetDeadlock = 0xf3,
  MSDeviceSwitchSnapshotStart = 0xf4,
  MSDeviceSwitchSnapshotEnd = 0xf5,
  MSRequestDevice = 0xf6, // 设备授权
  MTDeviceState = 0xf7,
  MTForgetDevice = 0xf8, // 测试- 清空授权
  MTSetOrReadSpecificItem = 0xf9,
  MTGetKeyZones = 0xfa, // 分区
  MTDeviceUpdate = 0xfc, // 设备固件更新
  MSDeviceUpdateProgress = 0xfd, // 固件更新进度
}
// ms  service=client
// mt  client=service
export interface DriverSocketMsg<T> {
  ID: string
  Type: DriverSocketMsgType
  Data: T
  Error: string
}
